// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__AT7Nm","legacyBtn":"MutateMid_legacyBtn__NU755"};